import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  .ant-breadcrumb {
    ol {
      list-style: none;
      padding-left: 0;
      margin-bottom: 0;
    }

    .ant-breadcrumb-link,
    .ant-breadcrumb-separator {
      font-size: 16px;
      /* color: ${theme.darkGray}; */
      color: ${theme.white};
      a {
        font-size: 16px;
        /* color: ${theme.darkGray}; */
        color: ${theme.white};

        &:hover {
          /* color: ${theme.primaryRed}; */
          text-decoration: underline;
        }
      }
    }

    /* span:last-child {
      .ant-breadcrumb-link {
        color: ${theme.primaryRed};
        a {
          color: ${theme.primaryRed};
        }
      }
    } */
  }
`
